import { FacebookPost } from "../../../utils/interfaces";

export interface LikeData {
    timestamp: string;
    count: number;
}

export interface Author {
    name: string;
    id: string;
}

export interface Comment {
    raw_id: string;
    message_content: string;
    url: string;
    from: Author;
    time_posted: string;
    likes: LikeData[];
    comments: Comment[];
}

export interface MappedFacebookPost {
    original_post: {
        raw_id: string;
        message_content: string;
        url: string;
        from: Author;
        time_posted: string;
        likes: LikeData[];
        comments: Comment[];
    };
}

export function mapFacebookPost(post: FacebookPost): MappedFacebookPost {
    return {
        original_post: {
            raw_id: post.id,
            message_content: post.message,
            url: post.url,
            from: {
                name: "",
                id: "",
            },
            time_posted: "",
            likes: [],
            comments: post.comments.map((comment) => ({
                raw_id: comment.id,
                message_content: comment.content,
                url: comment.message_url || "",
                from: {
                    name: comment.author.name,
                    id: comment.author.id,
                },
                time_posted: "",
                likes: [{ timestamp: "", count: comment.likes }],
                comments: (comment.comments || []).map((reply) => ({
                    raw_id: reply.id,
                    message_content: reply.content,
                    url: reply.message_url || "",
                    from: {
                        name: reply.author.name,
                        id: reply.author.id,
                    },
                    time_posted: "",
                    likes: [{ timestamp: "", count: reply.likes }],
                    comments: [],
                })),
            })),
        },
    };
}

export function mappedFacebookPostToJson(post: FacebookPost): string {
    const mappedPost = mapFacebookPost(post)
    const Json_post = JSON.stringify(mappedPost, null, 2);
    return Json_post
  }